import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const APP_ID = FIREBASE_CONFIG.projectId || 'portalrda-f312d';

export async function saveBackupCodes(uid, hashedCodes) {
  const backupRef = doc(db, 'artifacts', APP_ID, 'users', uid, 'security', 'backup_codes');
  await setDoc(backupRef, {
    codes: hashedCodes,
    generatedAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}
